{
	"name": "@mattilsynet/design",
	"version": "3.4.6",
	"type": "module",
	"repository": {
		"type": "git",
		"url": "git+ssh://git@github.com/Mattilsynet/design.git"
	},
	"main": "./mtds/index.js",
	"types": "./mtds/index.d.ts",
	"files": [
		"mtds"
	],
	"engines": {
		"npm": ">=10.0.0",
		"node": ">=20.0.0"
	},
	"exports": {
		".": {
			"import": "./mtds/index.js",
			"types": "./mtds/index.d.ts"
		},
		"./react": {
			"import": "./mtds/react.js",
			"types": "./mtds/react.d.ts"
		},
		"./atlas": {
			"import": "./mtds/atlas.js",
			"types": "./mtds/atlas.d.ts"
		},
		"./atlas/react": {
			"import": "./mtds/react-atlas.js",
			"types": "./mtds/react-atlas.d.ts"
		},
		"./*.svg": "./mtds/*.svg",
		"./*.ico": "./mtds/*.ico",
		"./ai/*": "./mtds/ai/*",
		"./icons/*": "./mtds/icons/*",
		"./illustrations/*": "./mtds/illustrations/*",
		"./index.iife.js": "./mtds/index.iife.js",
		"./atlas.iife.js": "./mtds/atlas.iife.js",
		"./package.json": "./package.json",
		"./styles.css": "./mtds/styles.css",
		"./styles.json": "./mtds/styles.json",
		"./tailwind.css": "./mtds/tailwind.css"
	},
	"scripts": {
		"build": "vite build --mode iife && vite build --mode iife-atlas && vite build && rm -rf mtds/docs/ && rm -rf mtds/iife.css",
		"build:tokens": "npx @digdir/designsystemet@latest tokens build --config designsystemet.config.json",
		"format": "npx @biomejs/biome format",
		"lint": "npx @biomejs/biome lint",
		"publish:clojure": "npm run build && cd ./clojure && ./publish.sh",
		"start": "vite",
		"storybook": "storybook dev -p 6006",
		"storybook:build": "npm run build && storybook build"
	},
	"devDependencies": {
		"@biomejs/biome": "2.5.8",
		"@digdir/designsystemet-css": "^1.19.1",
		"@digdir/designsystemet-types": "^1.19.1",
		"@handsontable/react-wrapper": "18.0.0",
		"@phosphor-icons/core": "^2.1.1",
		"@phosphor-icons/react": "^2.1.10",
		"@storybook/addon-docs": "^10.5.8",
		"@storybook/addon-themes": "^10.5.8",
		"@storybook/react-vite": "^10.5.8",
		"@tanstack/react-table": "^9.1.2",
		"@turf/boolean-point-in-polygon": "^7.4.0",
		"@turf/helpers": "^7.4.0",
		"@types/leaflet": "^1.9.22",
		"@types/leaflet.markercluster": "^1.5.6",
		"@types/node": "^26.2.0",
		"@types/react": "^19.2.18",
		"@types/react-dom": "^19.2.4",
		"@typescript/typescript6": "^6.0.2",
		"@vitejs/plugin-react": "^6.0.5",
		"fast-glob": "^3.3.3",
		"handsontable": "18.0.0",
		"leaflet": "^2.0.0-alpha.1",
		"postcss": "^8.5.26",
		"postcss-nesting": "^14.0.1",
		"react": "^19.2.8",
		"react-dom": "^19.2.8",
		"react-moveable": "^0.56.0",
		"storybook": "^10.5.8",
		"typescript": "^7.0.2",
		"unplugin-dts": "^1.0.3",
		"vite": "^8.2.1",
		"vite-plugin-static-copy": "^4.1.1"
	},
	"dependencies": {
		"@digdir/designsystemet-web": "^1.19.1",
		"@u-elements/u-progress": "1.0.1",
		"clsx": "^2.1.1"
	},
	"overrides": {
		"ajv": "^8.18.0",
		"ansi-regex": "^6.2.2",
		"ansi-styles": "^6.2.3",
		"chalk": "^5.6.2",
		"debug": "^4.4.3",
		"esbuild": "^0.28.1",
		"lodash": "^4.18.1",
		"minimatch": "^10.2.2",
		"strip-ansi": "^7.1.2",
		"supports-color": "^10.2.2",
		"tmp": "0.2.5",
		"wrap-ansi": "^9.0.1"
	}
}
